import { Button, Divider, Form, Input } from 'antd';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMedia } from 'react-use';
import { AppContext } from '../../AppContext';
import logo from '../../assets/logo.png';
import mobileLogo from '../../assets/mobileLogo.png';
import { Email, GoogleLogo, PasswordIcon } from '../../assets/svg';
import { ANALYTICS_EVENTS, BREAKPOINTS, ROUTES } from '../../common/constants';
import { formValidatorRules } from '../../common/utils';
import {
  analytics,
  SignInWithEmailAndPassword,
  SignInWithGoogle
} from './Firebase';

const { required } = formValidatorRules;

const Login = () => {
  const history = useHistory();
  const [googleLoading, setGoogleLoading] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const { initializeAuth } = useContext(AppContext);
  const isMobileViewPort = useMedia(`(min-width: ${BREAKPOINTS?.mobile}px)`);

  async function successCallback(
    accessToken,
    userData,
    isEmailVerified,
    isOnboardingCompleted
  ) {
    initializeAuth(accessToken, userData);
    // eslint-disable-next-line no-undef
    localStorage.setItem('isEmailVerified', isEmailVerified);
    // eslint-disable-next-line no-undef
    localStorage.setItem('isOnboardingCompleted', isOnboardingCompleted);

    setGoogleLoading(false);
    setLoginLoading(false);

    if (!isEmailVerified) {
      history.replace(ROUTES.VERIFY_EMAIL);
    } else if (!isOnboardingCompleted) {
      history.replace(ROUTES.FILL_PROFILE);
    } else {
      history.replace('/');
    }
  }

  const onFinish = async (formValues) => {
    try {
      const loggedIn = await SignInWithEmailAndPassword(
        formValues?.email,
        formValues?.password,
        setLoginLoading
      );
      if (loggedIn?.token) {
        successCallback(
          loggedIn?.token,
          loggedIn?.userData,
          loggedIn?.isEmailVerified,
          loggedIn?.success
        );
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  return (
    <div style={{ height: '100%' }} className="d-flex">
      {isMobileViewPort && (
        <div className="login">
          <img src={logo} alt="logo" className="logo" height="120px" />
          <div className="login-text">
            <h1>Making job equity a reality</h1>
            <p className="mt-25 font-16">
              A new employment platform that leverages A.I. & M.L. to make it
              easy for companies to find and hire Black talents, onboard and
              manage their experiences.
            </p>
            <Button
              className="create-account-button"
              onClick={() => {
                history.push(ROUTES.SIGNUP);
              }}
            >
              Create Account Now
            </Button>
          </div>
        </div>
      )}
      <div>
        {!isMobileViewPort && (
          <div className="mobile-login-header">
            <div className="d-flex align-center justify-between">
              <img src={mobileLogo} alt="logo" className="logo" height="35px" />
              <Button
                type="link"
                className="font-18 mobile-create-account-button"
                onClick={() => {
                  history.push(ROUTES.SIGNUP);
                }}
              >
                Create Account
              </Button>
            </div>
            <Divider />
          </div>
        )}
        <div className="login-screen">
          <h1>Login</h1>
          <p>
            Make the world more equitable by creating jobs, events, and
            communities that celebrate diversity.
          </p>

          <Button
            className="d-flex align-center fill-width font-18 mt-25 google-button justify-center"
            icon={<GoogleLogo className="google-logo" />}
            onClick={async () => {
              try {
                const logInSuccess = await SignInWithGoogle(setGoogleLoading);
                analytics.logEvent(ANALYTICS_EVENTS.USER_CONTINUE_GOOGLE, {
                  name: logInSuccess?.userData.name,
                  email: logInSuccess?.userData.email
                });
                await successCallback(
                  logInSuccess?.token,
                  logInSuccess?.userData,
                  logInSuccess?.isEmailVerified,
                  logInSuccess?.success
                );
              } catch (error) {
                setGoogleLoading(false);
                // eslint-disable-next-line no-console
                console.log(error);
              }
            }}
            loading={googleLoading}
          >
            Continue with Google
          </Button>
          <Divider />
          <div className="login-form">
            <Form layout="vertical" onFinish={onFinish}>
              <Form.Item label="Email" name="email" rules={[required]}>
                <Input prefix={<Email />} placeholder="Enter your Email" />
              </Form.Item>
              <Form.Item
                label="Password"
                className="mt-25"
                name="password"
                rules={[required]}
              >
                <Input.Password
                  placeholder="Enter your Password"
                  prefix={<PasswordIcon />}
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  className="fill-width"
                  htmlType="submit"
                  loading={loginLoading}
                >
                  Login
                </Button>
              </Form.Item>
              <div className="d-flex justify-center font-18 mt-25 flex-wrap">
                Forgot your password?
                <b
                  className="ml-5 pointer text-underline"
                  onClick={() => {
                    history.push(ROUTES.RESET);
                  }}
                >
                  Recover Password
                </b>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
